class ProductImages extends HTMLElement {
  constructor() {
    super();

    this.currentThumbIndex = 0;

    this.images = this.querySelectorAll(".product-image");
    this.thumbs = this.querySelectorAll(".image-thumbnail");

    this.btnNext = this.querySelector("#product-thumb-next");
    this.onNextClick = this.nextImage.bind(this);

    if (this.btnNext) {
      this.btnNext.addEventListener("click", this.onNextClick);
    }

    this.onThumbClick = this.handleThumbClick.bind(this);

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener("click", this.onThumbClick);
    });
  }

  handleThumbClick(evt) {
    const thumb = evt.target;

    const thumbIndex = parseInt(thumb.id.replace("product-thumb-", "")) - 1;
    console.log("thumbIndex", thumbIndex);

    this.currentThumbIndex = thumbIndex;
    this.changeActiveThumb();
    this.changeActiveImage();
  }

  nextImage(evt) {
    this.currentThumbIndex = this.currentThumbIndex + 1;
    if (this.currentThumbIndex >= this.thumbs.length) {
      this.currentThumbIndex = 0;
    }
    this.changeActiveThumb();
    this.changeActiveImage();
  }

  changeActiveThumb() {
    this.thumbs.forEach((thumb, index) => {
      if (index === this.currentThumbIndex) {
        thumb.classList.add("active");
      } else {
        thumb.classList.remove("active");
      }
    });

    const thumb = this.thumbs[this.currentThumbIndex];
    console.log("thumb", thumb, this.currentThumbIndex);
    thumb.scrollIntoView({
      block: "end",
      inline: "nearest",
    });
  }

  changeActiveImage() {
    const container = document.getElementById("product-images-slider");
    const image = this.images[this.currentThumbIndex];
    console.log(container, image);
    const containerRect = container.getBoundingClientRect();
    const imageRect = image.getBoundingClientRect();

    const scrollLeft =
      container.scrollLeft + (imageRect.left - containerRect.left);

    requestAnimationFrame(() => {
      container.scrollTo({
        left: scrollLeft,
        behavior: "smooth",
      });
    });
  }

  // changeActiveImage() {
  //   const image = this.images[this.currentThumbIndex];
  //   image.scrollIntoView({
  //     behavior: "smooth",
  //     block: "end",
  //     inline: "nearest",
  //   });
  // }
}

customElements.define("product-images", ProductImages);
